import * as tslib_1 from "tslib";
import { Router } from '@angular/router';
import { Actions as RootActions } from 'store/root-reducer';
import * as localforage from 'localforage';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable, of, from, zip } from 'rxjs';
import { switchMap, catchError, concatMap, map, filter, take } from 'rxjs/operators';
import { GetCustomer, GetCustomerSuccess, GetCustomerFailure, CustomerActionTypes, GetCustomersSuccess, GetCustomerDocumentsSuccess, GetCustomerDocumentsFailure, GetCrpsSuccess, GetCrpsFailure, GetCustomersFailure, GetUsersSuccess, GetUsersFailure, GetCrpSuccess, GetCrpFailure, CreateOrUpdateCustomerSuccess, CreateOrUpdateCustomerFailure, CreateOrUpdateCrpSuccess, CreateOrUpdateCrpFailure, GetCrpsWithoutPrimarySuccess, GetCrpsWithoutPrimaryFailure, PatchCustomerSuccess, PatchCustomerFailure, GetDefaultNotifiedUsersSuccess, GetDefaultNotifiedUsersFailure, SetDefaultNotifiedUsersSuccess, SetDefaultNotifiedUsersFailure, GetCustomersBatchUploadsListSuccess, GetCustomersBatchUploadsListFailure, UploadCustomersBatchFileSuccess, UploadCustomersBatchFileFailure, GetCustomerStatusSuccess, GetCustomerStatusFailure } from '../actions/customer.actions';
import { GetIndividualRecord, GetCorporateRecord } from '../actions/record.action';
import { RoleType } from 'modules/shared/models/role.models';
import { PostScreening } from 'store/actions/search.actions';
import { CustomerService } from 'modules/core/services/customer.service';
import { CrpService } from 'modules/core/services/crp.service';
import { SnackbarService } from 'app/services/snackbar.service';
export var LOCALFORAGE_LOCALSTORAGE_CONFIG = {
    driver: localforage.LOCALSTORAGE,
    name: 'artemis_2.1',
    description: 'This is localstorage for artemis 2.1'
};
var CustomerEffects = /** @class */ (function () {
    function CustomerEffects(actions$, customerService, crpService, router, snackbar) {
        var _this = this;
        this.actions$ = actions$;
        this.customerService = customerService;
        this.crpService = crpService;
        this.router = router;
        this.snackbar = snackbar;
        this.GetCustomer$ = this.actions$.pipe(ofType(CustomerActionTypes.GET_CUSTOMER), map(function (input) { return input.payload; }), switchMap(function (input) {
            return _this.customerService.getCustomer(input.customerId).pipe(switchMap(function (res) {
                return [new GetCustomerSuccess(res), new GetCustomerStatusSuccess(res.status)];
            }), catchError(function (error) {
                return of(new GetCustomerFailure(error.message));
            }));
        }));
        this.GetCustomerStatus$ = this.actions$.pipe(ofType(CustomerActionTypes.GET_CUSTOMER_STATUS), map(function (input) { return input.payload; }), switchMap(function (input) {
            return _this.customerService.getCustomer(input.customerId).pipe(switchMap(function (res) {
                return of(new GetCustomerStatusSuccess(res.status));
            }), catchError(function (error) {
                return of(new GetCustomerStatusFailure(error.message));
            }));
        }));
        this.GetCustomers$ = this.actions$.pipe(ofType(CustomerActionTypes.GET_CUSTOMERS), switchMap(function (input) {
            var customerPayload = Object.assign({}, input.payload);
            // As backend filter risks by searchAll we do this:
            if (customerPayload.risks && customerPayload.risks.length > 0) {
                customerPayload.searchAll = customerPayload.risks.toString();
                delete customerPayload.risks;
            }
            if (customerPayload.status && customerPayload.status.length > 0) {
                customerPayload.searchStatus = customerPayload.status.toString();
                delete customerPayload.status;
            }
            if (customerPayload.integrationStatus && customerPayload.integrationStatus.length > 0) {
                customerPayload.searchIntegrationStatus = customerPayload.integrationStatus.toString();
                delete customerPayload.integrationStatus;
            }
            return _this.customerService.getCustomers(customerPayload).pipe(switchMap(function (res) {
                return of(new GetCustomersSuccess(res));
            }), catchError(function (error) {
                return of(new GetCustomersFailure(error.message));
            }));
        }));
        this.GetCrp = this.actions$.pipe(ofType(CustomerActionTypes.GET_CRP), switchMap(function (input) {
            return _this.customerService.getCrp(input.payload.crpId).pipe(switchMap(function (res) {
                var actions$ = [new GetCrpSuccess(res)];
                if (res.recordType === 'INDIVIDUAL') {
                    actions$.push(new GetIndividualRecord({
                        recordId: res.record,
                        customerId: input.payload.customerId,
                        getOtherData: input.payload.getOtherData
                    }));
                }
                else if (res.recordType === 'CORPORATE') {
                    actions$.push(new GetCorporateRecord({
                        recordId: res.record,
                        customerId: input.payload.customerId,
                        getOtherData: input.payload.getOtherData
                    }));
                }
                if (input.payload.clearScreeningStatus && input.payload.customerId) {
                    actions$.push(new RootActions.pusher.ClearCustomer([input.payload.customerId]));
                }
                return actions$;
            }), catchError(function (err) { return of(new GetCrpFailure(err)); }));
        }));
        this.GetCrps = this.actions$.pipe(ofType(CustomerActionTypes.GET_CRPS), concatMap(function (res) {
            return _this.customerService.getCustomerCrps(res.payload).pipe(switchMap(function (crpRes) {
                var actions = [new GetCrpsSuccess(crpRes)];
                if (res.payload.clearScreeningStatus) {
                    actions.push(new RootActions.pusher.ClearCustomer([res.payload.customerId]));
                }
                return actions;
            }), catchError(function (err) { return of(new GetCrpsFailure(err)); }));
        }));
        this.GetCrpsWithoutPrimary = this.actions$.pipe(ofType(CustomerActionTypes.GET_CRPS_NO_PRIMARY), switchMap(function (res) {
            return _this.customerService.getCustomerCrps(res.payload)
                .pipe(switchMap(function (crpRes) {
                return of(new GetCrpsWithoutPrimarySuccess(crpRes));
            }), catchError(function (err) { return of(new GetCrpsWithoutPrimaryFailure(err)); }));
        }));
        this.GetDocuments = this.actions$.pipe(ofType(CustomerActionTypes.GET_CUSTOMER_DOCUMENTS), switchMap(function (input) {
            return _this.customerService.getDocuments(input.payload).pipe(switchMap(function (res) {
                return of(new GetCustomerDocumentsSuccess(res));
            }), catchError(function (err) { return of(new GetCustomerDocumentsFailure(err)); }));
        }));
        this.GetUsers$ = this.actions$.pipe(ofType(CustomerActionTypes.GET_SEARCH_USERS), switchMap(function (res) {
            res.payload.domain = res.payload.domainObject ? res.payload.domainObject.domainName : res.payload.domain;
            return _this.customerService.getUsers(res.payload)
                .pipe(switchMap(function (users) {
                return of(new GetUsersSuccess(users));
            }), catchError(function (err) { return of(new GetUsersFailure(err)); }));
        }));
        this.setDefaultNotifiedUsers = this.actions$.pipe(ofType(CustomerActionTypes.SET_DEFAULT_NOTIFIED_USERS), switchMap(function (action) {
            return zip(of(action.payload), from(_this.localStorage.getItem('defaultSelectedNotifiedUsers')));
        }), switchMap(function (_a) {
            var payload = _a[0], existingDefaultUserList = _a[1];
            var finalUsersObject = Object.assign({}, existingDefaultUserList);
            finalUsersObject[payload.domainId] = payload.users.map(function (user) { return user.oauthId; });
            if (!payload.users || payload.users.length === 0) {
                delete finalUsersObject[payload.domainId];
            }
            return from(_this.localStorage.setItem('defaultSelectedNotifiedUsers', finalUsersObject))
                .pipe(switchMap(function (users) {
                return of(new SetDefaultNotifiedUsersSuccess(payload.users));
            }), catchError(function (error) {
                return of(new SetDefaultNotifiedUsersFailure('Error Fetching from Local'));
            }));
        }));
        this.getDefaultNotifiedUsers = this.actions$.pipe(ofType(CustomerActionTypes.GET_DEFAULT_NOTIFIED_USERS), switchMap(function (action) {
            var userRequest = {
                limit: 999,
                offset: 0,
                domain: action.payload.domain.domainName
            };
            return zip(of(action.payload), _this.customerService.getUsers(userRequest)
                .pipe(filter(function (userList) { return !!userList && !!userList.results.length; }), take(1), map(function (userList) { return userList.results; })));
        }), switchMap(function (_a) {
            var payload = _a[0], userList = _a[1];
            return from(_this.localStorage.getItem('defaultSelectedNotifiedUsers'))
                .pipe(switchMap(function (usersOauthIdList) {
                var defaultUserList = [];
                if (usersOauthIdList[payload.domain.id] && usersOauthIdList[payload.domain.id].length) {
                    usersOauthIdList[payload.domain.id].forEach(function (defaultUserInLocalStorage) {
                        var matchIndex = userList.findIndex(function (user) {
                            if (typeof defaultUserInLocalStorage === 'string') {
                                return user.oauthId === defaultUserInLocalStorage;
                            }
                            else {
                                return user.oauthId === defaultUserInLocalStorage.oauthId;
                            }
                        });
                        if (!!~matchIndex) {
                            var defaultUser = {
                                checked: false,
                                name: userList[matchIndex].name,
                                email: userList[matchIndex].email,
                                l1: userList[matchIndex].roles.some(function (role) { return (role.name === RoleType.L1 && role.domain === payload.domain.id); }),
                                l2: userList[matchIndex].roles.some(function (role) { return (role.name === RoleType.L2 && role.domain === payload.domain.id); }),
                                l3: userList[matchIndex].roles.some(function (role) { return (role.name === RoleType.L3 && role.domain === payload.domain.id); }),
                                oauthId: userList[matchIndex].oauthId,
                            };
                            defaultUserList.push(defaultUser);
                        }
                    });
                }
                return of(new GetDefaultNotifiedUsersSuccess(defaultUserList));
            }), catchError(function (error) {
                return of(new GetDefaultNotifiedUsersFailure('Error Fetching from Local'));
            }));
        }));
        this.createOrUpdateCustomer$ = this.actions$.pipe(ofType(CustomerActionTypes.CREATE_OR_UPDATE_CUSTOMER), switchMap(function (res) {
            return _this.customerService.createOrUpdateCustomer(res.payload).pipe(switchMap(function (customer) {
                _this.router.navigateByUrl("customers/" + customer.id);
                return of(new CreateOrUpdateCustomerSuccess(customer));
            }), catchError(function (error) {
                if (error.error && error.error.detail) {
                    _this.snackbar.error(error.error.detail);
                }
                else {
                    _this.snackbar.error('Error: Failed to create or update customer, please try again later.');
                }
                return of(new CreateOrUpdateCustomerFailure(error.error.detail));
            }));
        }));
        this.createDraftCustomer$ = this.actions$.pipe(ofType(CustomerActionTypes.CREATE_DRAFT_CUSTOMER), switchMap(function (res) {
            return _this.customerService.createOrUpdateCustomer(res.payload).pipe(switchMap(function (customer) {
                _this.router.navigate(["customers/" + customer.id + "/edit"], { fragment: 'editCustomerCard' });
                return of(new CreateOrUpdateCustomerSuccess(customer));
            }), catchError(function (error) {
                if (error.error && error.error.detail) {
                    _this.snackbar.error(error.error.detail);
                }
                else {
                    _this.snackbar.error('Error: Failed to create customer, please try again later.');
                }
                return of(new CreateOrUpdateCustomerFailure(error.error.detail));
            }));
        }));
        this.createAndRACustomer$ = this.actions$.pipe(ofType(CustomerActionTypes.CREATE_AND_RA_CUSTOMER), switchMap(function (res) {
            return _this.customerService.createOrUpdateCustomer(res.payload).pipe(switchMap(function (customer) {
                return [
                    new CreateOrUpdateCustomerSuccess(customer),
                    new GetCustomer({
                        customerId: customer.id
                    }),
                    new PostScreening({
                        invalidOnly: true,
                        customer: customer,
                        redirectToScreening: true,
                        generateReport: true
                    })
                ];
            }), catchError(function (error) {
                if (error.error && error.error.detail) {
                    _this.snackbar.error(error.error.detail);
                }
                else {
                    _this.snackbar.error('Error: Failed to create customer, please try again later.');
                }
                return of(new CreateOrUpdateCustomerFailure(error.error.detail));
            }));
        }));
        this.createAndCRPCustomer$ = this.actions$.pipe(ofType(CustomerActionTypes.CREATE_AND_CRP_CUSTOMER), switchMap(function (res) {
            return _this.customerService.createOrUpdateCustomer(res.payload).pipe(switchMap(function (customer) {
                _this.router.navigate(["/customers/" + customer.id + "/edit/crp-add"], { fragment: 'addCrpCard' });
                return of(new CreateOrUpdateCustomerSuccess(customer));
            }), catchError(function (error) {
                if (error.error && error.error.detail) {
                    _this.snackbar.error(error.error.detail);
                }
                else {
                    _this.snackbar.error('Error: Failed to create customer, please try again later.');
                }
                return of(new CreateOrUpdateCustomerFailure(error.error.detail));
            }));
        }));
        this.createOrUpdateCrp$ = this.actions$.pipe(ofType(CustomerActionTypes.CREATE_OR_UPDATE_CRP), switchMap(function (res) {
            return _this.crpService.createOrUpdateCrp(res.payload).pipe(switchMap(function (crpRes) {
                _this.router.navigateByUrl("customers/" + res.payload.customer.id + "/edit/crp-edit/" + crpRes.id);
                return of(new CreateOrUpdateCrpSuccess(crpRes));
            }), catchError(function (error) {
                if (error.error && error.error.detail) {
                    _this.snackbar.error(error.error.detail);
                }
                else {
                    _this.snackbar.error('Error: Failed to create or update CRP, please try again later.');
                }
                return of(new CreateOrUpdateCrpFailure(error.error.detail));
            }));
        }));
        this.createAndRACrp$ = this.actions$.pipe(ofType(CustomerActionTypes.CREATE_AND_RA_CRP), switchMap(function (res) {
            return _this.crpService.createOrUpdateCrp(res.payload).pipe(switchMap(function (crpRes) {
                return [
                    new CreateOrUpdateCrpSuccess(crpRes),
                    new PostScreening({
                        invalidOnly: true,
                        customer: res.payload.customer,
                        generateReport: true,
                        redirectToScreening: true
                    })
                ];
            }), catchError(function (error) {
                if (error.error && error.error.detail) {
                    _this.snackbar.error(error.error.detail);
                }
                else {
                    _this.snackbar.error('Error: Failed to create CRP, please try again later.');
                }
                return of(new CreateOrUpdateCrpFailure(error.error.detail));
            }));
        }));
        this.createAndAddCrp$ = this.actions$.pipe(ofType(CustomerActionTypes.CREATE_AND_ADD_CRP), switchMap(function (res) {
            return _this.crpService.createOrUpdateCrp(res.payload).pipe(switchMap(function (crpRes) {
                _this.router.navigate(["/customers/" + res.payload.customer.id + "/edit/crp-add"], { fragment: 'addCrpCard' });
                return of(new CreateOrUpdateCrpSuccess(crpRes));
            }), catchError(function (error) {
                if (error.error && error.error.detail) {
                    _this.snackbar.error(error.error.detail);
                }
                else {
                    _this.snackbar.error('Error: Failed to create CRP, please try again later.');
                }
                return of(new CreateOrUpdateCrpFailure(error.error.detail));
            }));
        }));
        this.updateAndRACrp$ = this.actions$.pipe(ofType(CustomerActionTypes.UPDATE_AND_RA_CRP), switchMap(function (res) {
            return _this.crpService.createOrUpdateCrp(res.payload).pipe(switchMap(function (crpRes) {
                return [
                    new CreateOrUpdateCrpSuccess(crpRes),
                    new PostScreening({
                        invalidOnly: true,
                        generateReport: true,
                        redirectToScreening: true
                    })
                ];
            }), catchError(function (error) {
                if (error.error && error.error.detail) {
                    _this.snackbar.error(error.error.detail);
                }
                else {
                    _this.snackbar.error('Error: Failed to update CRP, please try again later.');
                }
                return of(new CreateOrUpdateCrpFailure(error.error.detail));
            }));
        }));
        this.updateAndAddCrp$ = this.actions$.pipe(ofType(CustomerActionTypes.UPDATE_AND_ADD_CRP), switchMap(function (res) {
            return _this.crpService.createOrUpdateCrp(res.payload).pipe(switchMap(function (crpRes) {
                _this.router.navigate(["/customers/" + res.payload.customer.id + "/edit/crp-add"], { fragment: 'addCrpCard' });
                return of(new CreateOrUpdateCrpSuccess(crpRes));
            }), catchError(function (error) {
                if (error.error && error.error.detail) {
                    _this.snackbar.error(error.error.detail);
                }
                else {
                    _this.snackbar.error('Error: Failed to update CRP, please try again later.');
                }
                return of(new CreateOrUpdateCrpFailure(error.error.detail));
            }));
        }));
        this.patchCustomer$ = this.actions$.pipe(ofType(CustomerActionTypes.PATCH_CUSTOMER), switchMap(function (res) {
            return _this.customerService.patchCustomer(res.payload.customer).pipe(switchMap(function (customer) {
                if (res.payload.redirectToCustomerList) {
                    _this.router.navigateByUrl('/customers');
                }
                return of(new PatchCustomerSuccess(customer));
            }), catchError(function (error) {
                if (error.error.detail) {
                    var errorObject = JSON.parse(error.error.detail);
                    if (errorObject.domains) {
                        return of(new PatchCustomerFailure('Domain validation error'));
                    }
                    else if (errorObject.users) {
                        return of(new PatchCustomerFailure('User validation error'));
                    }
                }
                return of(new PatchCustomerFailure('Unknown error happened, please try agan later or contact clientservice@cynopsis.co'));
            }));
        }));
        this.GetCustomersBatchUploadsList = this.actions$.pipe(ofType(CustomerActionTypes.GET_CUSTOMERS_BATCH_UPLOADS_LIST), map(function (action) { return action.payload; }), switchMap(function (payload) {
            return _this.customerService
                .getCustomersBatchUploads(payload.params)
                .pipe(switchMap(function (customersBatchUploadsResponse) {
                return of(new GetCustomersBatchUploadsListSuccess(customersBatchUploadsResponse));
            }), catchError(function (err) { return of(new GetCustomersBatchUploadsListFailure(err)); }));
        }));
        this.UploadCustomersBatchFile = this.actions$.pipe(ofType(CustomerActionTypes.UPLOAD_CUSTOMERS_BATCH_FILE), map(function (action) { return action.payload; }), switchMap(function (payload) {
            var httpRequestBody = {
                domains: payload.domains.map(function (domainId) { return domainId.toString(); }),
                file: payload.file,
                users: payload.users
            };
            return _this.customerService
                .uploadCustomersBatchFile(httpRequestBody)
                .pipe(switchMap(function (customersBatchUpload) {
                _this.snackbar.success('The customer batch upload is in progress.');
                return of(new UploadCustomersBatchFileSuccess(customersBatchUpload));
            }), catchError(function (err) {
                var errorText = 'Error: Failed to upload bulk file, please try again later.';
                if (err.error && err.error.detail) {
                    var detailsJSON = JSON.parse(err.error.detail);
                    var errorKeys = Object.keys(detailsJSON);
                    errorText = detailsJSON[errorKeys[0]];
                }
                _this.snackbar.error(errorText);
                return of(new UploadCustomersBatchFileFailure(err));
            }));
        }));
        this.localStorage = localforage.createInstance(LOCALFORAGE_LOCALSTORAGE_CONFIG);
    }
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], CustomerEffects.prototype, "GetCustomer$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], CustomerEffects.prototype, "GetCustomerStatus$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], CustomerEffects.prototype, "GetCustomers$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], CustomerEffects.prototype, "GetCrp", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], CustomerEffects.prototype, "GetCrps", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], CustomerEffects.prototype, "GetCrpsWithoutPrimary", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], CustomerEffects.prototype, "GetDocuments", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], CustomerEffects.prototype, "GetUsers$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], CustomerEffects.prototype, "setDefaultNotifiedUsers", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], CustomerEffects.prototype, "getDefaultNotifiedUsers", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], CustomerEffects.prototype, "createOrUpdateCustomer$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], CustomerEffects.prototype, "createDraftCustomer$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], CustomerEffects.prototype, "createAndRACustomer$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], CustomerEffects.prototype, "createAndCRPCustomer$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], CustomerEffects.prototype, "createOrUpdateCrp$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], CustomerEffects.prototype, "createAndRACrp$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], CustomerEffects.prototype, "createAndAddCrp$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], CustomerEffects.prototype, "updateAndRACrp$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], CustomerEffects.prototype, "updateAndAddCrp$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], CustomerEffects.prototype, "patchCustomer$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], CustomerEffects.prototype, "GetCustomersBatchUploadsList", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], CustomerEffects.prototype, "UploadCustomersBatchFile", void 0);
    return CustomerEffects;
}());
export { CustomerEffects };
